import { ScenarioHandler, BaseScenario, ScenarioType } from './types';
import { TicketScenario } from './scenarios/TicketScenario';
import { BuildingScenario } from './scenarios/BuildingScenario';
import { DocumentScenario } from './scenarios/DocumentScenario';

/**
 * Scenario Manager
 *
 * Beheert alle scenario handlers en detecteert automatisch
 * welk scenario van toepassing is op de gebruiker input.
 *
 * Nieuwe scenarios toevoegen:
 * 1. Maak een nieuwe ScenarioHandler class
 * 2. Voeg toe aan scenarios array in constructor
 */
export class ScenarioManager {
  private scenarios: ScenarioHandler[];

  constructor() {
    // Register all available scenarios
    this.scenarios = [
      new TicketScenario(),
      new BuildingScenario(),
      new DocumentScenario(), // NEW: Document and picture queries
      // Voeg hier nieuwe scenarios toe:
      // new FinancialScenario(),
      // new UnitScenario(),
      // etc.
    ];
  }

  /**
   * Detecteer welk scenario het beste past bij de input
   * Returns het scenario met de hoogste confidence score
   */
  detectScenario(input: string): { handler: ScenarioHandler; detection: BaseScenario } {
    let bestMatch = { handler: null as any, detection: { type: 'unknown' as ScenarioType, confidence: 0 } };

    for (const handler of this.scenarios) {
      const detection = handler.detect(input);

      if (detection.confidence > bestMatch.detection.confidence) {
        bestMatch = { handler, detection };
      }
    }

    return bestMatch;
  }

  /**
   * Get all example queries from all scenarios
   */
  getAllExamples(): Map<string, string[]> {
    const examples = new Map<string, string[]>();

    for (const handler of this.scenarios) {
      const scenarioName = handler.constructor.name.replace('Scenario', '');
      examples.set(scenarioName, handler.examples);
    }

    return examples;
  }

  /**
   * Get specific handler by scenario type
   */
  getHandler(type: ScenarioType): ScenarioHandler | null {
    const result = this.scenarios.find(s => {
      const detection = s.detect(`test ${type}`);
      return detection.type === type;
    });

    return result || null;
  }
}
